import PropTypes from "prop-types";
import { refPropType } from "../../propTypes";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import VideoPlayButton from "images/video_play.svg";
import VideoPause from "images/video_pause.svg";

export const AtomVideoPauseButton = ({ autoplayEnabled, onVideoPlayStateChanged, videoRef }) => {
  const isMobileViewport = useSelector(state => state.browser?.isMobileViewport);

  // Handle a11y requirement that allows user to pause video
  const [videoPaused, setVideoPaused] = useState(!autoplayEnabled);

  useEffect(
    function playOrPauseVideo() {
      if (videoPaused) {
        videoRef?.current?.pause();
      } else {
        videoRef?.current?.play();
      }
      onVideoPlayStateChanged?.(videoPaused);
    },
    [videoPaused, videoRef]
  );

  useEffect(function handlePrefersReducedMotion() {
    // If user prefers reduced motion, auto-pause the video
    if (videoRef?.current && window?.matchMedia?.("(prefers-reduced-motion)").matches) {
      setVideoPaused(true);
    }
  }, []);

  const handleClick = e => {
    //Prevent Pause/Play button from navigating when the video is wrapped in an anchor element
    e.preventDefault();
    setVideoPaused(!videoPaused);
  };

  return (
    <button
      onClick={handleClick}
      className="absolute bottom-2 right-2 bg-offWhite rounded-full overflow-hidden group transition-all duration-300">
      <div
        className="flex items-center justify-center p-2.5 transition-all duration-300"
        data-test-id={videoPaused ? "video-play-button" : "video-pause-button"}>
        {videoPaused ? <VideoPlayButton className="h-3 w-3 shrink-0" /> : <VideoPause className="h-3 w-3 shrink-0" />}
        {!isMobileViewport && (
          <span className="group-hover:ml-1 text-sm whitespace-nowrap overflow-hidden max-w-0 opacity-0 group-hover:max-w-28 group-hover:opacity-100 group-focus:max-w-28 group-focus:opacity-100 transition-all duration-300">
            {videoPaused ? "Play Video" : "Pause Video"}
          </span>
        )}
      </div>
    </button>
  );
};

AtomVideoPauseButton.propTypes = {
  autoplayEnabled: PropTypes.bool,
  onVideoPlayStateChanged: PropTypes.func,
  videoRef: refPropType.isRequired,
};

export default AtomVideoPauseButton;
